// @flow
/* eslint-env browser */
import './styles.css';
import { defineCustomElement } from '../../define-custom-element';

const carouselElements = [
    {
        text: 'Play Word Wipe',
        img: 'https://arenacloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-index/_arena-shared-content_/promoassets/WordWipe-300x150@2x.png',
        href: 'https://games.usatoday.com/games/word-wipe/?arkpromo=housead_word-wipe',
    },
    {
        text: 'Play Mahjongg Solitaire',
        img: 'https://arenacloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-index/_arena-shared-content_/promoassets/Mahjongg-Solitaire-300x150@2x.png',
        href: 'https://games.usatoday.com/games/mahjongg-solitaire/?arkpromo=housead_mahjongg-solitaire',
    },
    {
        text: 'Play Outspell',
        img: 'https://arenacloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-index/_arena-shared-content_/promoassets/Outspell-300x150@2x.png',
        href: 'https://games.usatoday.com/games/outspell/?arkpromo=housead_outspell',
    },
    {
        text: 'Play Klondike Solitaire',
        img: 'https://arenacloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-index/_arena-shared-content_/promoassets/Klondike-300x150@2x.png',
        href: 'https://games.usatoday.com/games/klondike-solitaire/?arkpromo=housead_klondike-solitaire',
    },
];

window.arkTrackAndGo = (url: string) => {
    if (window && window.appInsights) {
        window.appInsights.trackEvent({
            name: 'displayAdClick',
            url: window.location.href,
            target: url,
        });
    }

    setTimeout(() => { window.location = url; }, 250);

    return false;
};

const renderElement = ({ text, img, href }) => `
    <a title="${text}" href="${href}" onclick="return arkTrackAndGo('${href}')">
        <img alt="${text}" src="${img}"/>
    </a>
`;

export const renderCarousel = (container: Element) => {
    const existing = document.querySelector('div.ark-caroursel-container');

    if (existing) {
        existing.remove();
    }

    container.insertAdjacentHTML('afterbegin', `
        <div class="ark-caroursel-container">
            ${carouselElements.map(renderElement).join('\n')}
        </div>
    `);
};


export class USATPromo extends HTMLElement {
    connectedCallback() {
        const container = this;
        renderCarousel(container);
    }
}


defineCustomElement(USATPromo, 'usa-today-promo');
